<template>
    <content-view>
        <div class="wrap-container-in stored-detail">
            <div class="block-title">订单信息</div>
            <a-row class="mb16">
                <a-col :span="span">交易订单号：{{detailData.transNo}}</a-col>               
                <a-col :span="span">会员姓名：{{detailData.name || detailData.account}}</a-col>               
                <a-col :span="span">会员手机号：{{detailData.phone}}</a-col>               
            </a-row>
            <a-row class="mb16">
                <a-col :span="span">订单状态：{{detailData.tradeState}}</a-col>               
                <a-col :span="span">下单时间：{{detailData.orderTime}}</a-col>                
                <a-col :span="span">支付时间：{{detailData.payTime || '--'}}</a-col>                
            </a-row>
            <a-row class="mb16">
                <a-col :span="span">应收金额：{{detailData.orderAmount}} 元</a-col>                
                <a-col :span="span">实收金额：{{detailData.payAmount || '0'}} 元</a-col>                
                <a-col :span="span">支付方式：{{$utils.payMode[detailData.payMode] || "--"}}</a-col>                
            </a-row>
            <a-row class="mb16" v-if="detailData.platformName">
                <a-col :span="span" v-if="detailData.platform">购买途径：{{detailData.platform}}</a-col>                
                <a-col :span="span">票台名称：{{detailData.platformName}}</a-col>               
                <a-col :span="span">收银员：{{detailData.cashier}}</a-col>               
            </a-row>
            <a-row class="mb16">
                <a-col :span="span">购买门店：{{detailData.shopName || '总部'}}</a-col>                
                <a-col :span="span">是否人工确认：{{detailData.isManualPayment ? '是' : "否"}}</a-col>                
            </a-row>
            <div class="block-title">储值营销活动</div>
            <a-row class="mb16">
                <a-col :span="span">赠送情况：{{detailData.tips || '-'}}</a-col>                
                <a-col :span="span">赠送积分：{{detailData.givePoints || '-'}}</a-col>                
            </a-row>
            <div class="text-center mt32">
                <a-button @click="$router.go(-1)">返回</a-button>
            </div>
        </div>
    </content-view>
</template>
<script>
export default {
    name: 'storedValueDetail',
    zn: '储值订单详情',
    data() {
        return {
            span: 8,
            detailData: {}
        }
    },
    methods: {
        getDetail() {
            this.$api.order
                .viewTrade({
                    body: {   
                        transNo: this.$route.query.orderId,
						source: 'BALANCE'
                    }
                })
                .then(res => {
                    res.tradeState = this.$route.query.tradeState
                    this.detailData = res;
                });
        }
    },
    mounted() {
        this.getDetail()
    }
}
</script>
<style lang="scss">
    .stored-detail {
        .block-title {
            margin: 16px 0;
            font-size: 16px;
            line-height: 32px;
            font-weight: 900;
            color: rgba(0, 0, 0, 0.85);
        }
    }
</style>

